import { closeModal } from "@mantine/modals";
import { FxIdSdk } from "@sdk/FxIdSdk.ts";
import { IFxIdSdkAdapterInviteFriendsRequest } from "@sdk/FxIdSdkTypes.ts";

const PLACEHOLDER_INVITE_TEXT = "";

export const inviteFriends = async (fxIdInstance: FxIdSdk | null | undefined) => {
	if (fxIdInstance == null) {
		log.warn("inviteFriends - fxidInstance is null");
		return;
	}

	const options: IFxIdSdkAdapterInviteFriendsRequest = { inviteText: PLACEHOLDER_INVITE_TEXT };
	const request = JSON.stringify(options);
	closeModal("social");
	await fxIdInstance.InviteFriends(request);
};
